module.exports = __webpack_public_path__ + "img/img_01.fc6e171c.png";